import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";
import { cx } from "@/utils/cx";
import type { ConditionDisplayParts } from "@/utils/workflow-rules/format";

interface WorkflowRuleConditionLabelProps {
	parts: ConditionDisplayParts;
	/** When true, inherit monospace styling for overview summary lines. */
	mono?: boolean;
}

/**
 * Renders a readable condition label with the field ID available on hover.
 */
export function WorkflowRuleConditionLabel({
	parts,
	mono = false,
}: WorkflowRuleConditionLabelProps) {
	const textClass = cx("text-sm text-gray-800", mono && "font-mono");

	const fieldNode = parts.fieldId ? (
		<Tooltip title={parts.fieldId} placement="top">
			<TooltipTrigger
				className={cx(
					"inline cursor-default underline decoration-dotted decoration-gray-400 underline-offset-2",
					textClass,
				)}
			>
				{parts.fieldLabel}
			</TooltipTrigger>
		</Tooltip>
	) : (
		<span className={textClass}>{parts.fieldLabel}</span>
	);

	if (!parts.operatorLabel && parts.fieldLabel === "—") {
		return <span className={textClass}>—</span>;
	}

	if (parts.valueLabel === null) {
		return (
			<span className={textClass}>
				{fieldNode} {parts.operatorLabel}
			</span>
		);
	}

	return (
		<span className={textClass}>
			{fieldNode} {parts.operatorLabel} '{parts.valueLabel}'
		</span>
	);
}
